<template>
  <v-container>
    <!-- barra -->
    <v-app-bar
      app
      absolute
      dark
      color="primary"
      elevation="3"
      height="56"
      extension-height="40px"
      scroll-target="#app-container"
    >
      <v-btn icon to="/">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-toolbar-title class="pl-0">
        <span class="font-weight-bold">{{ nombreDia }}</span>
        <span class="font-weight-bold"> {{ infoFecha.dia }}</span>
        <span class="body-2"> - {{ nombreMes }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-model="showMenu" :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-card width="300px" class="pa-4 mb-0">
          <v-slider
            label="Tamaño letra"
            v-model="ucMddTam"
            min="1"
            max="5"
            step="1"
            tick-size="1"
          ></v-slider>
        </v-card>
      </v-menu>
      <!-- menu -->
      <v-dialog
        v-model="showDateDialog"
        persistent
        ref="dateDialog"
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>event</v-icon>
          </v-btn>
        </template>
        <v-date-picker
          v-model="fechaCalendario"
          :locale="userConfig.lng"
          :min="appContext.min"
          :max="appContext.max"
          no-title
        >
          <v-spacer></v-spacer>
          <v-btn text @click="showDateDialog = false">Cancel</v-btn>
          <v-btn text color="primary" @click="goDay()">OK</v-btn>
        </v-date-picker>
      </v-dialog>
      <!-- extension -->
      <template v-slot:extension>
        <v-container class="py-0">
          <v-row align="center">
            <!-- Semana salterio -->
            <div class="body-2 ml-2 yellow--text text--lighten-4">
              {{ salterio }}
            </div>
            <v-spacer></v-spacer>
            <!-- Colores -->
            <v-tooltip left v-model="showTooltip">
              <template v-slot:activator="{ on }">
                <div
                  v-on="on"
                  @click.stop="showTooltip = !showTooltip"
                  class="body-2 yellow--text text--lighten-4 mr-1"
                >
                  <span
                    class="color-lit"
                    :class="color"
                    v-for="color in colores"
                    :key="color"
                  ></span>
                </div>
              </template>
              <span>{{ t.lecturas.colorLiturgia }}</span>
            </v-tooltip>
          </v-row>
        </v-container>
      </template>
    </v-app-bar>
    <!-- contenido -->
    <v-content class="zoom">
      <v-container
        v-touch="{
          left: () => goNextDay(),
          right: () => goPrevDay()
        }"
      >
        <!-- Título y subtítulo -->
        <v-row align="center">
          <v-col>
            <h4 class="subtitle">
              {{ t.lecturas.biblicas }}
            </h4>
            <div class="body-2 grey--text">{{ lectio.celeb }}</div>
          </v-col>
        </v-row>

        <!-- contenidos -->
        <div>
          <!-- lecturas -->
          <v-row>
            <!-- TODO: evaluar si evento touchend se puede cambiar por touchstart or touchchange-->
            <v-col class="pt-2">
              <div
                class="font-italic font-weight-bold primary--text"
                v-text="lectio.lbPrimera"
              ></div>
              <div v-html="lectio.txtPrimera"></div>
              <div
                class="font-italic font-weight-bold primary--text"
                v-text="lectio.lbSalmo"
              ></div>
              <div
                class="font-italic font-weight-bold primary--text"
                v-html="lectio.rtaSalmo"
              ></div>
              <div v-html="lectio.txtSalmo"></div>
              <div
                class="font-italic font-weight-bold primary--text"
                v-text="lectio.lbSegunda"
              ></div>
              <div v-html="lectio.txtSegunda"></div>
              <div
                class="font-italic font-weight-bold primary--text"
                v-text="lectio.lbEvang"
              ></div>
              <div v-html="lectio.txtEvang"></div>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-content>
  </v-container>
</template>

<script>
import userConfigEdit from "../../mixs/mixUserConfigEdit";
import store from "../../store/_store";
import infoo from "../../plugins/infoo";

import { Touch } from "vuetify/lib/directives";

export default {
  name: "mdd-lecturas-biblicas",
  mixins: [userConfigEdit],
  directives: { touch: Touch },
  beforeRouteUpdate(to, from, next) {
    // TODO: cambiar esta referencia directa
    // context.min se calcula de la fecha minima de la version del libro
    let hoy = infoo.hoy;
    let params = to.params;

    let dateMin = store.state.app.context.min || hoy.min; // fecha en formato iso
    let dateMax = store.state.app.context.max;
    let dateTo = infoo.fechaAMD(params.anio, params.mes, params.dia).iso;

    if (dateTo < dateMin) {
      dateMin = infoo.fechaIso(dateMin);
      params.dia = dateMin.dia;
      params.mes = dateMin.mes;
      params.anio = dateMin.anio;
      store.dispatch("lectio/load", params);
      next({ name: "MddLecturasBiblicas", params: params });
      return;
    }

    if (dateTo > dateMax) {
      dateMax = infoo.fechaIso(dateMax);
      params.dia = dateMax.dia;
      params.mes = dateMax.mes;
      params.anio = dateMax.anio;
      store.dispatch("lectio/load", params);
      next({ name: "MddLecturasBiblicas", params: params });
      return;
    }

    // al terminar la validacion carga
    store.dispatch("lectio/load", params);
    next();
  },
  mounted() {
    this.fechaCalendario = this.infoFecha.iso;
  },
  data() {
    return {
      showDateDialog: false,
      showTooltip: false,
      fechaCalendario: "",
      showMenu: false
    };
  },
  computed: {
    appContext() {
      return this.$store.getters["app/context"];
    },
    colorBtn() {
      return this.tieneHls ? "primary" : "warning";
    },
    colores() {
      return this.lectio.color ? this.lectio.color.split(" ") : [];
    },
    docId() {
      let prms = this.$route.params;
      let date = new Date(prms.anio, prms.mes - 1, prms.dia, 0, 0, 0);
      return date.toISOString().slice(0, 10);
    },
    infoFecha() {
      let p = this.$route.params;
      return infoo.fechaAMD(p.anio, p.mes, p.dia);
    },
    lectio() {
      let search = {
        uid: this.docId,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      return this.$store.getters["lectio/fromSearch"](search);
    },
    lectioLoad() {
      return this.lectio.txtEvange !== "";
    },
    nextDay() {
      let unDiaMas = this.infoFecha.fecha.getTime() + 24 * 60 * 60 * 1000;
      return infoo.fechaTime(unDiaMas);
    },
    nombreDia() {
      return this.t.dias[this.infoFecha.diaSem];
    },
    nombreMes() {
      return " " + this.t.meses[this.infoFecha.mes];
    },
    prevDay() {
      let unDiaMenos = this.infoFecha.fecha.getTime() - 24 * 60 * 60 * 1000;
      return infoo.fechaTime(unDiaMenos);
    },
    salterio() {
      let sem = [
        "",
        "Salterio I",
        "Salterio II",
        "Salterio III",
        "Salterio IV"
      ];
      return sem[this.lectio.sem];
    },
    showSanto() {
      return this.userConfig && this.userConfig.orm
        ? this.userConfig.orm.san
        : false;
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    }
  },
  methods: {
    goDay() {
      this.showDateDialog = false;
      var fecha = infoo.fechaIso(this.fechaCalendario);
      if (this.fechaCalendario === this.docId) {
        return;
      }

      let params = {
        anio: fecha.anio,
        mes: fecha.mes,
        dia: fecha.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      this.$router
        .push({ name: "MddLecturasBiblicas", params: params })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 197,
            src: "mdd-portada-libro"
          });
        });
    },
    goNextDay() {
      if (this.nextDay.iso > this.appContext.max) {
        return;
      }
      this.fechaCalendario = this.nextDay.iso;

      let params = {
        anio: this.nextDay.anio,
        mes: this.nextDay.mes,
        dia: this.nextDay.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      this.$router
        .push({ name: "MddLecturasBiblicas", params: params })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 197,
            src: "mdd-portada-libro"
          });
        });
    },
    goPrevDay() {
      if (this.prevDay.iso < this.appContext.min) {
        return;
      }
      this.fechaCalendario = this.prevDay.iso;

      let params = {
        anio: this.prevDay.anio,
        mes: this.prevDay.mes,
        dia: this.prevDay.dia,
        lng: this.userConfig.mdd.lng,
        ver: this.userConfig.mdd.ver
      };
      this.$router
        .push({ name: "MddLecturasBiblicas", params: params })
        .catch(e => {
          this.$store.dispatch("app/saveErrorReport", {
            e: e,
            line: 327,
            src: "mdd-lecturas-biblicas"
          });
        });
    }
  }
};
</script>

<style>
.rta,
.pregReflex {
  color: #00bcd4;
  font-style: italic;
  font-weight: bold;
}

.color-lit {
  display: inline-block;
  margin-left: 8px;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  padding: 8px;
  border: 1px solid rgba(0, 0, 0, 0.25);
}

.color-lit.M {
  background-color: #ab47bc;
}
.color-lit.R {
  background-color: #ef5350;
}
.color-lit.Ros {
  background-color: #f48fb1;
}
.color-lit.B {
  background-color: white;
}
.color-lit.V {
  background-color: #66bb6a;
}
</style>
